<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <!--{{item.money}}-->
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="830px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div class="wid_img">
          <div>
            <img :src="item01.photoUrl" alt="暂无图片" />
          </div>
          <div class="Introduction">
            <div class="Introduction__p">介 绍：{{ item01.p }}</div>
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/SolarRobot/guangfu1.png",
          p: "南秀挂式光伏板清扫机器人搭载智能核心清洁系统，支持定时预约清扫，后台可调整清扫任务与强度，可全面清扫光伏板表面的灰尘、鸟粪、落叶等各类顽固污渍。配合高精度滚刷，实现无死角深度清洁。采用太阳能自充电技术，利用光伏板余电或独立太阳能板为设备续航；当电量不足时，可立即停下充电，充满后继续未完成任务，实现全天候无人化值守内置多重智能防护，当设备出现倾斜或遇到障碍物时，系统实时后台报警，运维人员可第一时间掌握异常情况并远程处理。",
          ref: "壁挂式光伏板清洁机器人",
        },
        {
          photoUrl: "../../../static/img/SolarRobot/guangfu2.png",
          p: "履带式光伏清扫机器人，专为各类工商业厂房、山地、荒漠、屋顶光伏电站量身打造，依托稳固履带行走结构，适配复杂坡面、凹凸地面，全自动完成光伏板表面积灰、落叶、沙尘、鸟粪清理作业，大幅提升光伏板发电效率，降低人工清扫成本，是光伏电站日常运维必备清洁设备。",
          ref: "履带式光伏清扫机器人",
        },
        {
          photoUrl: "../../../static/img/SolarRobot/moqiang.png",
          p: "真空吸附爬墙机器人面向墙面打磨作业场景，采用模块化设计，由真空吸附底盘、磨墙执行机构、履带移动驱动、分层控制系统以及多传感器感知系统组成，依靠多独立腔体真空吸附实现墙面可靠附着，浮动缓冲磨墙机构可适配墙面凹凸误差，履带结构保障复杂墙面通行能力，搭配多传感器融合完成环境建模、障碍物识别与姿态监测，可实现墙面自主打磨、粉尘同步收集；项目总工期 20 周，目前已完成方案细化、参数计算与大部分核心部件选型采购，吸附、打磨吸尘两大核心系统的部件与测试环境均已就绪，部分风机、真空泵完成性能摸底测试，整机三维结构设计已经启动，后续将开展风机、打磨部件专项性能测试，完成系统集成调试、联合性能优化后交付产品，该机器人具备充足吸附安全冗余，可实现打磨‑吸尘联动，能够替代人工完成高处墙面打磨作业，提升作业效率与施工安全性。",
          ref: "真空吸附爬墙机器人",
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.wid_img img {
  width: 364px;
  height: 330px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
  margin-top: -32px;
}

.buy_col01 {
  border-radius: 6px;
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/SolarRobot.vue